import { render, staticRenderFns } from "./vcSelectConceptServiceAccount.vue?vue&type=template&id=dc898950&"
import script from "./vcSelectConceptServiceAccount.vue?vue&type=script&lang=js&"
export * from "./vcSelectConceptServiceAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports